import React from "react";
import EditContainer from "../EditContainer";
import { PAGES } from "../../../util/constants/pages";

export const FinanceApprovalEditContainer = () => (
  <EditContainer page={PAGES.FINANCE_APPROVAL} />
);
